import { CurationPlatformAppId, getCurationPlatformAppUrl } from '@verantos-dev/shared-layout';

const ACCURACY_DASHBOARD_PATH = '/accuracy-dashboard';

const ACCURACY_DEEP_LINK_PARAM_NAMES = {
  optimizationProjectId: 'opid',
  setName: 'batch',
  accuracyIterationId: 'iid',
} as const;

export interface AccuracyDeepLinkTarget {
  optimizationProjectId?: string | null;
  setName?: string | null;
  accuracyIterationId?: string | null;
}

/**
 * Absolute URL into the Accuracy Dashboard, deep-linked to a project, batch and
 * iteration. The annotation-tool `projectId` and the dashboard's
 * `optimizationProjectId` are different values, so callers must pass the
 * dashboard-side identifiers resolved from an accuracy job row. Returns `null`
 * when the Accuracy Dashboard URL is not configured (see
 * `getCurationPlatformAppUrl`, which also reports the misconfiguration to
 * Sentry).
 */
// TODO: cleanup with cp_trigger_accuracy_from_ui ff
export const buildAccuracyDashboardUrl = (target: AccuracyDeepLinkTarget): string | null => {
  const baseUrl = getCurationPlatformAppUrl(CurationPlatformAppId.accuracyDashboard);
  if (!baseUrl) {
    return null;
  }
  const url = new URL(ACCURACY_DASHBOARD_PATH, baseUrl);
  if (target.optimizationProjectId) {
    url.searchParams.set(
      ACCURACY_DEEP_LINK_PARAM_NAMES.optimizationProjectId,
      target.optimizationProjectId
    );
  }
  if (target.setName) {
    url.searchParams.set(ACCURACY_DEEP_LINK_PARAM_NAMES.setName, target.setName);
  }
  if (target.accuracyIterationId) {
    url.searchParams.set(
      ACCURACY_DEEP_LINK_PARAM_NAMES.accuracyIterationId,
      target.accuracyIterationId
    );
  }
  return url.toString();
};
